import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ElectricianProvinceClient.tsx");
